import React from 'react'

import {
  Card,
  CardImg,
  CardBlock,
  CardTitle,
} from 'components/qstrap'
import Typography from 'components/atoms/Typography'
import { string } from 'prop-types'

import config from 'config'

const { assets_url: assetsUrl } = config

const MajorItem = ({ img, imgAlt, title, desc }) => (
  <div className="kit-majors__item">
    <Card className="kit-majors__card">
      <CardImg
        src={`${assetsUrl}${img || '/assets/img/placeholder-jurusan.svg'}`}
        alt={imgAlt || title}
        className="img-responsive"
        top
      />
      <CardBlock>
        <CardTitle>
          { title }
        </CardTitle>
        <div className="card-text">
          <Typography component="p" variant="body">
            {desc}
          </Typography>
        </div>
      </CardBlock>
    </Card>
  </div>
)

MajorItem.propTypes = {
  img: string,
  title: string,
  desc: string,
  imgAlt: string,
}

export default MajorItem
